import { Payload } from "recharts/types/component/DefaultLegendContent";
import { Tenant } from "./multiple-tenants.type";

export enum DataSource {
  Myntra = "MYNTRA",
}

export interface CustomLegenPayload extends Payload {
  dataKey?: string | number | ((obj: unknown) => unknown);
}

export interface CustomLegendProps {
  payload?: CustomLegenPayload[];
}

export type PaginatedResponse<T> = {
  page: number;
  totalElements: number;
  totalPages: number;
  data: T[];
};
export type ValueType = "mrp" | "asp" | "discount";

export type DataItem<T = string> = {
  label: string;
  value: T;
};

export type SkuData = {
  articleType: string;
  availableCount: number;
  averageRating: number;
  baseColor: string;
  brand: string;
  collar: null | string;
  countryOfOrigin: string;
  discountedPrice: number;
  fabric: string;
  fabric2: string;
  fit: string;
  gender: string;
  image1: string;
  image2: string;
  image3: string;
  image4: string;
  isFastFashion: boolean;
  length: string;
  mainTrend: string;
  manufacturerInfo: string;
  masterCategory: string;
  materialAndCare: string;
  measurementName1: string;
  measurementName2: string;
  measurementUnit1: string;
  measurementUnit2: string;
  measurementValue1: string;
  measurementValue2: string;
  mrp: number;
  occasion: string;
  packerInfo: string;
  season: string;
  sellerPartnerId: number;
  size: string;
  skuId: number;
  sleeveLength: null | string;
  styleId: number;
  subCategory: string;
  year: string;
};

export type StyleIdData = {
  articleType: string;
  averageRating: number;
  baseColor: string;
  brand: string;
  collar: string | null;
  fabric: string;
  fabric2: string;
  fit: string;
  gender: string;
  images: string[];
  isFastFashion: boolean;
  length: string;
  mainTrend: string;
  masterCategory: string;
  materialAndCare: string;
  occasion: string;
  season: string;
  skus: {
    availableCount: number;
    countryOfOrigin: string;
    discountedPrice: number;
    manufacturerInfo: string;
    measurements: {
      measurementName1: string;
      measurementName2: string;
      measurementUnit1: string;
      measurementUnit2: string;
      measurementValue1: string;
      measurementValue2: string;
    };
    mrp: number;
    packerInfo: string;
    sellerPartnerId: number;
    size: string;
    sku: number;
  }[];
  sleeveLength: string | null;
  styleId: number;
  subCategory: string;
  year: string;
};

export type StyleIdDataAggregated = {
  styleId: string;
  images: string[];
  skus: string[];
  year: string;
  occasion: string;
  subCategory: string;
  collar: string | null;
  gender: string;
  length: string;
  mainTrend: string;
  averageDiscountedPrice: number;
  fit: string;
  fabric2: string;
  masterCategory: string;
  averageMrp: number;
  articleType: string;
  fabric: string;
  materialAndCare: string;
  averageRating: number;
  season: string;
  sleeveLength: string | null;
  totalAvailableCount: number;
  baseColor: string;
  brand: string;
  isFastFashion: boolean;
};
export type AnalyticsData = {
  id: number;
  scheduledJobId: number;
  jobStyleAssignmentId: number;
  styleId: string;
  dataSource: string;
  availableCount: number;
  mrp: number;
  discountedPrice: number;
  gender: string;
  brand: string;
  articleType: string;
  processDate: string;
  createdBy: string | null;
  createdDate: string;
  lastModifiedBy: string | null;
  lastModifiedAt: string;
};

export type ScheduledJob = {
  id: number;
  jobName: string;
  totalStyleIds: number;
  startTime: string | null;
  endTime: string | null;
  frequency: number | null;
  lastExecutionTime: string | null;
  active: boolean;
  scheduledJobStatus: "SUCCESS" | "FAILED" | "INPROGRESS";
  tenants: Tenant[];
};

export type UploadedFileData = {
  styleId: string;
  dataSource: DataSource;
  isValid: boolean;
  validationMessage: string;
  isDuplicate: boolean | null;
};

export type UploadedSessionData = {
  id: number;
  jobName: string;
  inputType: string;
  dataSource: DataSource;
  styleIds: {
    styleId: string;
    dataSource: DataSource;
  }[];
};
